// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__KNven"};